// extracted by mini-css-extract-plugin
export default {"customTable":"CustomTable_customTable__0NnL3","actions":"CustomTable_actions__0UCZa"};